import React from 'react';

import styled from 'styled-components';

import useConfigurations from '@hooks/Configurations/UseConfigurations';

import Money from '@components/Gui/Money';

import StatementOriginalAmount from '../StatementOriginalAmount';
import StatementTaxesDetails from '../StatementTaxesDetails';

const TotalDetailsContainer = styled.div`
    dl.line-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 0;
        line-height: 1.25em;
        padding-top: 0.25rem;

        dt {
            text-transform: uppercase;
            font-weight: 300;
            font-size: ${(props) => props.theme.FontSizeSm};
            color: ${(props) => props.theme.TextColorMuted};
        }

        dd {
            margin: 0;
            min-width: 6.8rem;
        }

        &.last {
            padding-bottom: 0.25rem;
        }
    }

    dl.tax-line-container {
        dt {
            padding-right: 0 !important;
            font-size: ${(props) => props.theme.FontSizeXSm};
        }

        dd {
            min-width: 6.8rem;
        }
    }
`;

/**
 * ReceivableTotalColumn
 *
 * Displays total details for receivable (client) statements
 * Simpler than payable - displays single statement with taxes
 */
const ReceivableTotalColumn = ({ statement, transaction, printable, isExpanded }) => {
    const configuration = useConfigurations();
    const statementCurrency = transaction.Currency;
    const isDefaultCurrency = statementCurrency === configuration.defaultCurrency;

    const SingleLine = ({ taxed }) => {
        if (!isDefaultCurrency) {
            if (statement.ExchangeRate > 0) {
                return (
                    <>
                        <Money
                            redIfNegative={!printable}
                            amount={taxed ? statement.TaxedAmountDef : statement.AmountDef}
                            currency={configuration.defaultCurrency}
                        />
                        <StatementOriginalAmount
                            amount={taxed ? statement.TaxedAmount : statement.Amount}
                            currency={statementCurrency}
                            printable={printable}
                        />
                    </>
                );
            } else {
                return (
                    <Money
                        highlightCurrency={!printable}
                        redIfNegative={!printable}
                        amount={taxed ? statement.TaxedAmount : statement.Amount}
                        currency={statementCurrency}
                    />
                );
            }
        } else {
            return (
                <Money
                    redIfNegative={!printable}
                    amount={taxed ? statement.TaxedAmountDef : statement.AmountDef}
                    currency={configuration.defaultCurrency}
                />
            );
        }
    };

    return (
        <TotalDetailsContainer>
            {isExpanded ? (
                <>
                    <p>
                        <SingleLine />
                    </p>
                    <StatementTaxesDetails statement={statement} statementCurrency={statementCurrency} />
                    {statement.Amount !== statement.TaxedAmount && (
                        <p>
                            <SingleLine taxed />
                        </p>
                    )}
                </>
            ) : (
                <p>
                    <SingleLine taxed />
                </p>
            )}
        </TotalDetailsContainer>
    );
};

export default ReceivableTotalColumn;

